const PREFIX = '0bF';

// Base64 encoding
export const encode = (str: string) => {
  const encoded = btoa(str);
  return encoded.replace(/=/g, '');
};

// Base64 decoding
export const decode = (str: string) => {
  const padding = '='.repeat((4 - (str.length % 4)) % 4);
  const decoded = atob(str + padding);
  return decoded;
};

// Obfuscate a string by encoding it with Base64, prefixing and reversing the result
export const obfuscate = (str: string) => {
  const encoded = encode(PREFIX + str);
  const reversed = encoded.split('').reverse().join('');
  return reversed;
};

// Deobfuscate a string by reversing it, decoding it with Base64, and removing the prefix
export const deobfuscate = (str: string) => {
  const reversed = str.split('').reverse().join('');
  const decoded = decode(reversed);
  return decoded.slice(PREFIX.length);
};
